import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { CssBaseline, Box } from '@mui/material';
import { AuthProvider } from '@features/auth';
import { CustomThemeProvider } from './app/providers/ThemeContext';
import { NotificationProvider } from './features/notifications/context/NotificationContext';
import { ChatProvider } from './app/providers/ChatContext';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <CustomThemeProvider>
        <CssBaseline />
        <BrowserRouter>
          <NotificationProvider>
            <ChatProvider>
              <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                <AppRoutes />
              </Box>
            </ChatProvider>
          </NotificationProvider>
        </BrowserRouter>
      </CustomThemeProvider>
    </AuthProvider>
  );
};

export default App;
